// The server picks the language of its error messages from this header.
export const LOCALE_HEADER_NAME = 'x-locale';
